import NewVersionContainer from './NewVersionContainer';

export default NewVersionContainer;
